import { render } from "./academic_post92_check.html?vue&type=template&id=09ccc5d6&scoped=true&external"
import script from "./academic_post92_check.js?vue&type=script&lang=js&external"
export * from "./academic_post92_check.js?vue&type=script&lang=js&external"

import "./AcademicPost92CheckReport.vue?vue&type=style&index=0&id=09ccc5d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ccc5d6"]])

export default __exports__